export default __webpack_public_path__ + "static/media/482346164_645380227865174_6826758922577828762_n.f9508cfd.jpg";